import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @closeModal={{@closeModal}}
  @title={{i18n "user.second_factor.totp.add"}}
  {{did-insert this.totpRequested}}
>
  <:body>
    <ConditionalLoadingSpinner @condition={{this.loading}}>
      {{#if this.errorMessage}}
        <div class="control-group">
          <div class="controls">
            <div class="alert alert-error">{{this.errorMessage}}</div>
          </div>
        </div>
      {{/if}}

      <div class="control-group">
        <div class="controls">
          {{html-safe (i18n "user.second_factor.enable_description")}}
        </div>
      </div>

      <div class="control-group">
        <div class="controls">
          <div class="qr-code">
            <img src={{html-safe this.secondFactorImage}} />
          </div>
          <p>
            {{#if this.showSecondFactorKey}}
              <div class="second-factor-key">
                {{this.secondFactorKey}}
              </div>
            {{else}}
              <a
                href
                class="show-second-factor-key"
                {{on "click" this.enableShowSecondFactorKey}}
              >{{i18n "user.second_factor.show_key_description"}}</a>
            {{/if}}
          </p>
        </div>
      </div>

      <div class="control-group">
        <label class="control-label input-prepend">{{i18n
            "user.second_factor.name"
          }}</label>
        <div class="controls">
          <input
            {{on "input" (with-event-value (fn (mut this.secondFactorName)))}}
            value={{this.secondFactorName}}
            type="text"
            placeholder={{i18n "user.second_factor.totp.default_name"}}
            maxlength={{this.maxSecondFactorNameLength}}
            id="second-factor-name"
          />
        </div>

        <label class="control-label input-prepend">
          {{i18n "user.second_factor.label"}}
        </label>
        <div class="controls">
          <SecondFactorInput
            {{on "input" (with-event-value (fn (mut this.secondFactorToken)))}}
            @secondFactorMethod={{this.totpType}}
            value={{this.secondFactorToken}}
            placeholder="123456"
            id="second-factor-token"
          />
        </div>
      </div>

      <div class="control-group">
        <div class="controls">
          <DButton
            class="btn-primary add-totp"
            @action={{this.enableSecondFactor}}
            @label="enable"
          />
        </div>
      </div>
    </ConditionalLoadingSpinner>
  </:body>
</DModal>
*/
{
  "id": "Ib6HT1CJ",
  "block": "[[[8,[39,0],[[4,[38,2],[[30,0,[\"totpRequested\"]]],null]],[[\"@closeModal\",\"@title\"],[[30,1],[28,[37,1],[\"user.second_factor.totp.add\"],null]]],[[\"body\"],[[[[1,\"\\n    \"],[8,[39,3],null,[[\"@condition\"],[[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"errorMessage\"]],[[[1,\"        \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"alert alert-error\"],[12],[1,[30,0,[\"errorMessage\"]]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[[28,[37,1],[\"user.second_factor.enable_description\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"qr-code\"],[12],[1,\"\\n            \"],[10,\"img\"],[15,\"src\",[28,[37,5],[[30,0,[\"secondFactorImage\"]]],null]],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n\"],[41,[30,0,[\"showSecondFactorKey\"]],[[[1,\"              \"],[10,0],[14,0,\"second-factor-key\"],[12],[1,\"\\n                \"],[1,[30,0,[\"secondFactorKey\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[11,3],[24,6,\"\"],[24,0,\"show-second-factor-key\"],[4,[38,6],[\"click\",[30,0,[\"enableShowSecondFactorKey\"]]],null],[12],[1,[28,[35,1],[\"user.second_factor.show_key_description\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"control-label input-prepend\"],[12],[1,[28,[35,1],[\"user.second_factor.name\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n          \"],[11,\"input\"],[16,2,[30,0,[\"secondFactorName\"]]],[16,\"placeholder\",[28,[37,1],[\"user.second_factor.totp.default_name\"],null]],[16,\"maxlength\",[30,0,[\"maxSecondFactorNameLength\"]]],[24,1,\"second-factor-name\"],[24,4,\"text\"],[4,[38,6],[\"input\",[28,[37,7],[[28,[37,8],[[28,[37,9],[[30,0,[\"secondFactorName\"]]],null]],null]],null]],null],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,\"label\"],[14,0,\"control-label input-prepend\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"user.second_factor.label\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n          \"],[8,[39,10],[[16,2,[30,0,[\"secondFactorToken\"]]],[24,\"placeholder\",\"123456\"],[24,1,\"second-factor-token\"],[4,[38,6],[\"input\",[28,[37,7],[[28,[37,8],[[28,[37,9],[[30,0,[\"secondFactorToken\"]]],null]],null]],null]],null]],[[\"@secondFactorMethod\"],[[30,0,[\"totpType\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n          \"],[8,[39,11],[[24,0,\"btn-primary add-totp\"]],[[\"@action\",\"@label\"],[[30,0,[\"enableSecondFactor\"]],\"enable\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\"],false,[\"d-modal\",\"i18n\",\"did-insert\",\"conditional-loading-spinner\",\"if\",\"html-safe\",\"on\",\"with-event-value\",\"fn\",\"mut\",\"second-factor-input\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/second-factor-add-totp.hbs",
  "isStrictMode": false
});